<template>
  <generic-modal :title="$t('document log')" ref="generic_modal">
    <!-- <div class="title is-6">{{ $t("events") }}</div> -->
    <div class="timeline">
      <header class="timeline-header">
        <span class="tag is-medium is-primary">{{ $t("start") }}</span>
      </header>
      <div class="timeline-item pb-0" v-for="log in meta" :key="log.uuid">
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <p class="heading">{{ format_date_time(log.create_date) }}</p>
          <p>{{ log.message }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="content">
      <ul>
        <li v-for="log in meta" :key="log.uuid">
          <div class="title is-6">{{ log.message }}</div>
          <div class="subtitle is-6">
            {{ format_date_time(log.create_date) }}
          </div>
        </li>
      </ul>
    </div>
    <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  format_date_time,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "LogModal",
  components: { GenericModal },
  data() {
    return {
      meta: [],
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.addressee_id;
    },
  },
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      if (uuid) {
        get("/document-sign/document/log", { uuid: uuid })
          .then((res) => {
            v.meta = res;
          })
          .catch((err) => {
            v.error = error_message(err);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = [];
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
